module.exports = __webpack_public_path__ + "img/nu.433deb3d.svg";